import { render, staticRenderFns } from "./WinStreak.vue?vue&type=template&id=06b34100&scoped=true"
import script from "./WinStreak.vue?vue&type=script&lang=js"
export * from "./WinStreak.vue?vue&type=script&lang=js"
import style0 from "./WinStreak.vue?vue&type=style&index=0&id=06b34100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b34100",
  null
  
)

export default component.exports